<template>
  <div class="footer-container">
    <div class="footer-wrapper flex">
      <div v-for="(item, index) in menus" :key="item.id" class="footer-item">
        <span class="footer-text" @click="handleSelect(1, item)">{{item.name}}</span>
        <div v-for="child in item.children" :key="child.id">
          <span class="child-text" @click="handleSelect(2, child)">{{child.name}}</span>
        </div>
        <div v-if="index === menus.length - 1" class="guanwei flex">
          <div>
            <div>文旅博览集团</div>
            <div>官方微信</div>
          </div>
          <img src="../../assets/images/weixin.jpg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menus from "@/config/menus"
export default {
  name: 'Footer',
  data () {
    return {
      menus: menus.filter(item => item.id !== "008" && !item.meta?.hidden)
    }
  },
  methods: {
    handleSelect(level, menu) {
      if (level === 1) {
        this.$router.push(`/index/lists/${menu.id}`);
        return;
      }
      if (level === 2) {
        this.$router.push(`/index/lists/${menu.id}`);
        return;
      }
      this.$router.push("/");
    },
  }
}
</script>

<style lang="scss" scoped>
.footer-container {
  background: #efefef;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  padding-top: 10px;
  .footer-wrapper {
    width: 1005px;
    margin: 0 auto;
    color: #333;
    .footer-item {
      width: 112px;
      background: url("../../assets/images/link-bg.jpg") no-repeat center right;
      text-align: center;
      &:first-child {
        width: 95px;
        text-align: left;
      }
      &:last-child {
        flex: 1;
        background: none;
        text-align: left;
        padding-left: 38px;
      }
      .guanwei {
        font-size: 12px;
        color: #666;
        white-space: nowrap;
        margin-top: 10px;
        img {
          width: 65px;
          height: 65px;
          margin-left: 60px;
        }
      }
    }
    .footer-text {
      line-height: 50px;
      margin-top: 5px;
      font-size: 14px;
      cursor: pointer;
      &:hover {
        color: #fcc200;
        text-decoration: underline;
      }
    }
    .child-text {
      font-size: 12px;
      line-height: 23px;
      cursor: pointer;
      &:hover {
        color: #fcc200;
        text-decoration: underline;
      }
    }
  }
}
</style>